/* export const myAction = async({commit})=> {} */
import { fetchWithToken } from "@/helpers/fetch";
import router from "@/router";
import { PAGE_SIZE } from "@/modules/shared/constants/table";

export const search = async ({ commit }, { payload, page }) => {
  commit("digitalLettersSearch", { isLoading: true, error: "" });
  try {
    const response = await fetchWithToken(
      "/letter/search?page=" + page + "&limit=" + PAGE_SIZE,
      payload,
      "POST",
      false
    );
    const data = await response.json();
    if (!response.ok || !Array.isArray(data.data)) {
      const message = data && data.errors ? Object.values(data.errors).flat().join(" ") : data && data.message;
      throw new Error(message || "No se pudieron consultar las letras.");
    }
    data.data.forEach((letter) => {
      letter.isLoadingPDF = false;
    });
    commit("digitalLettersSearch", { ...data, isLoading: false });
  } catch (error) {
    // Sin esto, un error del API dejaba el loading eterno.
    console.error(error);
    commit("digitalLettersSearch", { data: [], total: 0, last_page: 1, isLoading: false, error: error.message });
  }
};

export const getDocument = async ({ commit }, { id }) => {
  try {
    const response = await fetchWithToken("/letter/pdf", { id }, "POST", false);
    if (response.status !== 404) {
      const fileBlob = await response.blob();
      let fileUrl = null;
      let status = false;
      if (fileBlob.type === "application/pdf") {
        fileUrl = URL.createObjectURL(fileBlob);
        status = true;
      }
      return { success: status, fileUrl };
    }
    return { success: false, fileUrl: null };

  } catch (ex) {
    return { success: false, fileUrl: null };
  }


};

export const getClients = async ({ commit, rootState }, { page, limit, search }) => {
  const response = await fetchWithToken(`/client?page=${page}&limit=${limit}&fc_company=${rootState.user.company}&search=${search}`, "GET");
  const data = await response.json()
  return data.data
};

export const updateClient = async ({ commit }, payload) => {
  const response = await fetchWithToken(
    "/client/" + payload.id,
    payload,
    "PUT",
    false
  );
  const data = await response.json();
  return data
};

export const createClient = async ({ commit }, payload) => {
  const response = await fetchWithToken(
    "/client",
    payload,
    "POST",
    false
  );
  const data = await response.json();
  return data
};

export const uploadClients = async ({ commit }, payload) => {
  const formData = new FormData();
  formData.append("file", payload);

  const response = await fetchWithToken(
    "/import/users",
    formData,
    "POST",
    true
  );
  const data = await response.json();
  return data
};

export const viewAsClient = async ({ commit }, userId) => {
  const response = await fetchWithToken(`/client/${userId}/impersonate`, "GET");
  const { token, id, rol } = await response.json();

  const adminData = {
    token: localStorage.getItem('x-token'),
    role: localStorage.getItem('role'),
    id: localStorage.getItem('x-id')
  };

  localStorage.setItem('admin-data', JSON.stringify(adminData));
  commit('auth/loginUser', {
    token: token,
    rol: rol,
    id: id
  }, { root: true })

  router.push('/usuario/facturacion')
  // window.location.reload();
};

// Vendedores (rol 5): listado, alta y edición desde el panel.
export const fetchSalesUsers = async ({ commit }) => {
  commit("salesUsers", { isLoading: true });
  try {
    const response = await fetchWithToken("/sales-users");
    const data = await response.json();
    if (response.status !== 200 || !data || !Array.isArray(data.data)) {
      commit("salesUsers", { data: [], isLoading: false });
      return { success: false, message: data && data.message ? data.message : "" };
    }
    commit("salesUsers", { data: data.data, isLoading: false });
    return { success: true };
  } catch (error) {
    console.error(error);
    commit("salesUsers", { data: [], isLoading: false });
    return { success: false, message: "" };
  }
};

// Desactivar (deja la empresa) o reactivar un vendedor. No se borra.
export const setSalesUserStatus = async ({ commit }, { id, active }) => {
  commit("salesUsers", { isSaving: true });
  try {
    const response = await fetchWithToken("/sales-users/" + id + "/status", { active }, "PATCH");
    const data = await response.json();
    if (response.status !== 200) {
      return { success: false, message: data && data.message ? data.message : "" };
    }
    return { success: true, message: data.message };
  } catch (error) {
    console.error(error);
    return { success: false, message: "" };
  } finally {
    commit("salesUsers", { isSaving: false });
  }
};

export const saveSalesUser = async ({ commit }, { isNew, id, ...payload }) => {
  commit("salesUsers", { isSaving: true });
  try {
    const response = isNew
      ? await fetchWithToken("/sales-users", payload, "POST")
      : await fetchWithToken("/sales-users/" + id, payload, "PUT");
    const data = await response.json();
    if (response.status !== 200) {
      const message = data && data.errors
        ? Object.values(data.errors).flat().join(" ")
        : (data && data.message ? data.message : "");
      return { success: false, message };
    }
    return { success: true, message: data.message };
  } catch (error) {
    console.error(error);
    return { success: false, message: "" };
  } finally {
    commit("salesUsers", { isSaving: false });
  }
};
